import { Grid } from 'semantic-ui-react';

import YandexLogo from './assets/Yandex.jpg';
import BMSTULogo from './assets/BMSTU.jpg';
import NagradionLogo from './assets/Nagradion.jpg';
import MercauxLogo from './assets/Mercaux.jpg';
import { FormattedMessage } from 'react-intl';

export const Content = () => (
  <Grid.Row>
    <Grid.Column width={8}>
      <h2 className="ui medium header"><FormattedMessage id="title.Work experience" /></h2>
      <div className="ui raised segment">

        {/* Mercaux */}
        <span className="ui yellow ribbon label company">
          <img className="ui middle circular aligned mini image" src={MercauxLogo}></img>
          <span className="company-name">Mercaux</span>
        </span>
        <div className="experience-header">
          <div><FormattedMessage id="Web developer" /></div>
          <div className="date"><FormattedMessage id="dates.Nov 2022 - Feb 2026" /></div>
        </div>
        <p>
          <ul className="ui divided list">
            {Array.from({ length: 7 }).map((_, index) => (
              <li className="item" key={index}>
                <FormattedMessage id={`text.mercauxExp_${index + 1}` as FormatjsIntl.Message['ids']} />
              </li>
            ))}
          </ul>
        </p>

        {/* Yandex */}
        <span className="ui yellow ribbon label company">
          <img className="ui middle circular aligned mini image" src={YandexLogo}></img>
          <span className="company-name"><FormattedMessage id="Yandex" /></span>
        </span>
        <div className="experience-header">
          <div><FormattedMessage id="Frontend developer" /></div>
          <div className="date"><FormattedMessage id="dates.Nov 2018 - Apr 2022 (3 years 6 months)" /></div>
        </div>
        <p>
          <FormattedMessage id="text.yandexExp_0" />
          <ul className="ui divided list">
            {Array.from({ length: 5 }).map((_, index) => (
              <li className="item" key={index}>
                <FormattedMessage id={`text.yandexExp_${index + 1}` as FormatjsIntl.Message['ids']} />
              </li>
            ))}
          </ul>
        </p>

        {/* Nagradion */}
        <span className="ui blue ribbon label company">
          <img className="ui middle aligned mini image" src={NagradionLogo}></img>
          <span><FormattedMessage id="Nagradion" /></span>
        </span>
        <div className="experience-header">
          <div><FormattedMessage id="Junior frontend developer" /></div>
          <div className="date"><FormattedMessage id="dates.Oct 2017 - Sep 2018 (1 year)" /></div>
        </div>
        <p>
          <FormattedMessage id="text.nagradionExp_0" />
          <ul className="ui devided list">
            {Array.from({ length: 2 }).map((_, index) => (
              <li className="item" key={index}>
                <FormattedMessage id={`text.nagradionExp_${index + 1}` as FormatjsIntl.Message['ids']} />
              </li>
            ))}
          </ul>
        </p>
      </div>
      <h2 className="ui medium header"><FormattedMessage id="title.Education" /></h2>
      <div className="ui segment">
        <div className="education-item">
          <img className="ui left floated top aligned mini image" src={BMSTULogo}></img>
          <div className="content">
            <div className="description"><FormattedMessage id="Bauman Moscow State technical university" /></div>
            <div className="meta"><FormattedMessage id="text.degree" /></div>
            <div className="date"><FormattedMessage id="dates.2013 - 2017" /></div>
          </div>

        </div>
      </div>
    </Grid.Column>
    <Grid.Column width={8}>
    <h2 className="ui medium header"><FormattedMessage id="title.Portfolio" /></h2>
      <div>
        <div>
          <a className='ui label basic selflink' href='https://pavelpivkin.github.io'>pavelpivkin.github.io</a>
          <a className='ui label basic' href='https://github.com/pavelpivkin'>github.com/PavelPivkin</a>
          <a className='ui label basic' href='https://medium.com/@iamdreamer'>Medium</a>
        </div>
      </div>
      <h2 className="ui medium header"><FormattedMessage id="title.Skills" /></h2>
      <div>
        <div className="ui green horizontal label">Html</div>
        <div className="ui green horizontal label">CSS</div>
        <div className="ui green horizontal label">Sass</div>
        <div className="ui green horizontal label">Styl</div>
        <div className="ui green horizontal label">Javascript (ES6)</div>
        <div className="ui green horizontal label">React</div>
        <div className="ui green horizontal label">React Router</div>
        <div className="ui green horizontal label">React Context API</div>
        <div className="ui green horizontal label">React Flow</div>
        <div className="ui green horizontal label">Redux</div>
        <div className="ui green horizontal label">Typescript</div>
        <div className="ui green horizontal label">Chrome-devconsole</div>
        <div className="ui green horizontal label">Webpack</div>
        <div className="ui green horizontal label">Babel</div>
        <div className="ui green horizontal label">Nodejs</div>
        <div className="ui green horizontal label">Web perfomance</div>
        <div className="ui green horizontal label">Jest</div>
        <div className="ui green horizontal label">Selenium</div>
        <div className="ui green horizontal label">Git</div>
        <div className="ui green horizontal label">Npm</div>
      </div>
      <h2 className="ui medium header"><FormattedMessage id="title.Languages" /></h2>
      <div className="ui divided list">
        <div className="item">
          <i className="flag ru"></i>
          <span className="content"><b><FormattedMessage id="Russian" /></b> - <FormattedMessage id="Native" /></span>
        </div>
        <div className="item">
          <i className="flag gb uk"></i>
          <span className="content"><b><FormattedMessage id="English" /></b> - <FormattedMessage id="Upper-Intermediate" /></span>
        </div>
        <div className="item">
          <i className="flag es"></i>
          <span className="content"><b><FormattedMessage id="Spanish (Castellano)" /></b> - <FormattedMessage id="Beginner" /></span>
        </div>
      </div>
      {/* <h2 className="ui medium header">Certifications and awards</h2>
          <h2 className="ui medium header">Personal projects</h2>
          <h2 className="ui medium header">Volunteer Experience</h2> */}
      <h2 className="ui medium header"><FormattedMessage id="title.Interests" /></h2>
      <div>
        <div className="ui blue horizontal label"><FormattedMessage id="Sport" /></div>
        <div className="ui blue horizontal label"><FormattedMessage id="Hiking" /></div>
        <div className="ui blue horizontal label"><FormattedMessage id="Camping" /></div>
        <div className="ui blue horizontal label"><FormattedMessage id="Gamedev" /></div>
      </div>
      {/* <h2 className="ui medium header">Additional Info</h2>
      <div>Opened for remote work and relocation</div> */}
    </Grid.Column>
  </Grid.Row>
);